import { format } from "date-fns";

export function fmtYearMonth(d: Date = new Date()) {
  return format(d, "yyyy-MM");
}
export function fmtDate(d: Date = new Date()) {
  return format(d, "yyyy-MM-dd");
}
export function fmtDateTime(d: Date) {
  return format(d, "yyyy-MM-dd HH:mm");
}

// buildingHo 표시 — 숫자 호수는 "호"를 붙이고, 주택 층("1층")은 그대로 둔다.
export function fmtHo(ho?: string) {
  if (!ho) return "";
  return ho.endsWith("층") ? ho : `${ho}호`;
}

export function maskPhone(p: string) {
  if (!p) return "";
  const first = p.split(",")[0];
  return first.replace(/(\d{3})-?(\d{3,4})-?(\d{4})/, "$1-$2-$3");
}
